// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"270":"3dc7a95c","858":"dcdb2f3b"}[chunkId] + ".chunk.css";
};